import Swiper from 'swiper';

class ProductListSlider {
  constructor (elem) {
    this._elem = elem
    this._target = this._elem.dataset.productListSlider
  }

  onInit () {
    const swiperSettings = {
      autoplay: false,
      cache: false,
      loop: false,
      slidesPerView: 2.2,
      slidesPerGroup: 2,
      hashNavigation: {
        watchState: true,
      },
      pagination: {
        el: `.swiper-pagination-${this._target}`,
        clickable: true,
        type: "bullets"
      },
      breakpoints: {
        1024: {
          slidesPerView: 4,
          spaceBetween: 24
        }
      }
    }
    new Swiper(`.swiper-${this._target}`, swiperSettings);
  }
}
export default ProductListSlider
